import React, { useState, FormEvent, useContext, useEffect } from "react";
import { Segment, Form, Button } from "semantic-ui-react";
import { IProjectChangeRequest, ITransmission as ITransmission } from "../../../app/models/transmission";
import TransmissionStore from "../../../app/stores/transmissionStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";

interface DetailParams {
  id: string;
}

const TransmissionEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const transmissionStore = useContext(TransmissionStore);
  const { loadTransmission, editTransmission, clearTransmission, submitting } = transmissionStore;

  const [transmission, setTransmission] = useState<ITransmission>({
    id: "0",
    createdAt: "",
    updatedAt: "",
    projectCode: "",
    jobType: "",
    customerId: "",
    orderNumber: "",
    materialOrderNo: "",
    status: "",
    address: "",
    jobStartDate: "",
    estimatedCompletionDate: "",
    invoiceNo: "",
    remark: "",
    projectSite: {
      id: "0",
      createdAt: "",
      updatedAt: "",
      projectId: "0",
      ringId: "",
      state: "",
      siteId: "",
      siteName: "",
      upstreamSiteId: "",
      upstreamSiteName: "",
      upstreamWP: 0,
      address: "",
      structureType: "",
      sequence: 0,
      time: "",
      remark: "",
      changeRequest: [{
        id: "0",
        createdAt: "",
        updatedAt: "",
        projectSiteId: "0",
        changeRequestNumber: "",
        dates: "",
        remark: "",
      }],
    }
  });

  useEffect(() => {
    loadTransmission(match.params.id).then((transmission) => {
      setTransmission(transmission);
    });

    return () => {
      clearTransmission();
    };
  }, []);

  const handleSubmit = () => {
    editTransmission(transmission).then(() =>
      history.push(`/projectmanagement/transmission`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setTransmission({ ...transmission, [name]: value });
  };

  const status = [
    { key: "PO", text: "PO", value: "PO" },
    { key: "Scheduled", text: "Scheduled", value: "Scheduled" },
    { key: "Onhold", text: "Onhold", value: "Onhold" },
    {
      key: "HOP",
      text: "HOP",
      value: "HOP",
    },
    {
      key: "Invoice",
      text: "Invoice",
      value: "Invoice",
    },
    { key: "Complete", text: "Complete", value: "Complete" },
    { key: "Closed", text: "Closed", value: "Closed" },
  ];

  const type = [
    { key: "POC1", text: "POC1", value: "POC1" },
    { key: "POC2", text: "POC2", value: "POC2" },
    { key: "POC3", text: "POC3", value: "POC3" },
    { key: "POC4", text: "POC4", value: "POC4" },
  ];

  const time = [{ key: "Day", text: "Day", value: "Day" },
  { key: "Night", text: "Night", value: "Night" }];

  const comp = [
    { key: "Efiniti", text: "Efiniti", value: "Efiniti" },
    { key: "CAM", text: "CAM", value: "CAM" },
  ];

  var newArray: IProjectChangeRequest[] = [{
    id: transmission.projectSite.changeRequest[0].id,
    createdAt: "",
    updatedAt: "",
    projectSiteId: transmission.projectSite.changeRequest[0].projectSiteId,
    changeRequestNumber: transmission.projectSite.changeRequest[0].changeRequestNumber,
    dates: transmission.projectSite.changeRequest[0].dates,
    remark: "",
  }]

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Group widths="equal">
          <Form.Input
            label="Project Code"
            onChange={handleInputChange}
            name="projectCode"
            placeholder="Project Code"
            value={transmission.projectCode}
          />
          <Form.Select
            label="Type"
            onChange={(e, { name, value }) =>
              setTransmission({
                ...transmission,
                projectSite: { ...transmission.projectSite, [name]: value },
              })
            }
            name="structureType"
            width="8"
            required
            placeholder="Type"
            options={type}
            value={transmission.projectSite.structureType}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Select
            label="Company"
            required
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, [name]: value })
            }
            options={comp}
            name="orderNumber"
            placeholder="Company"
            value={transmission.orderNumber}
          /> 
          <Form.Input
            label="Ring Id"
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, projectSite: { ...transmission.projectSite, [name]: value } })
            }
            name="ringId"
            placeholder="Ring Id"
            value={transmission.projectSite.ringId}
          />
          <Form.Select
            label="Status"
            required
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, [name]: value })
            }
            options={status}
            name="status"
            placeholder="Status"
            value={transmission.status}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Site Id"
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, projectSite: { ...transmission.projectSite, [name]: value } })
            }
            name="siteId"
            placeholder="Site Id"
            value={transmission.projectSite.siteId}
          />
          <Form.Input
            label="Upstream Site Id"
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, projectSite: { ...transmission.projectSite, [name]: value } })
            }
            name="upstreamSiteId"
            placeholder="Upstream Site Id"
            value={transmission.projectSite.upstreamSiteId}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Upstream WP"
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, projectSite: { ...transmission.projectSite, [name]: value } })
            }
            name="upstreamWP"
            placeholder="Upstream WP"
            value={transmission.projectSite.upstreamWP}
          />
          <Form.Input
            label="Sequence"
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, projectSite: { ...transmission.projectSite, [name]: value } })
            }
            name="sequence"
            placeholder="Sequence"
            value={transmission.projectSite.sequence}
          />
        </Form.Group>
        <Form.Group widths="equal">
        <Form.Input
            label="Address"
            onChange={(e, { name, value }) =>
              setTransmission({
                ...transmission,
                projectSite: { ...transmission.projectSite, [name]: value },
              })
            }
            name="address"
            placeholder="Address"
            value={transmission.projectSite.address}
          />
          <Form.Input
            label="Structure Type"
            onChange={(e, { name, value }) =>
              setTransmission({
                ...transmission,
                projectSite: { ...transmission.projectSite, [name]: value },
              })
            }
            name="structureType"
            placeholder="Structure Type"
            value={transmission.projectSite.structureType}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Forecast Date"
            onChange={handleInputChange}
            name="estimatedCompletionDate"
            type="date"
            placeholder="Forecast Date"
            value={transmission.estimatedCompletionDate}
          />
          <Form.Select
            label="Day/Night"
            onChange={(e, { name, value }) =>
              setTransmission({ ...transmission, projectSite: { ...transmission.projectSite, [name]: value } })
            }
            name="time"
            placeholder="Day/Night"
            options={time}
            value={transmission.projectSite.time}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Change Request No"
            onChange={(e, { name, value }) => {
              newArray[0].changeRequestNumber = value;
              setTransmission({
                ...transmission, projectSite: {
                  ...transmission.projectSite,
                  changeRequest: newArray
                }
              })
            }
            }
            name="changeRequestNumber"
            placeholder="Change Request No"
            value={transmission.projectSite.changeRequest[0].changeRequestNumber}
          />
          <Form.Input
            label="Change Request Dates"
            onChange={(e, { name, value }) => {
              newArray[0].dates = value;
              setTransmission({
                ...transmission, projectSite: {
                  ...transmission.projectSite,
                  changeRequest: newArray
                }
              })
            }
            }
            name="dates"
            placeholder="Change Request Dates"
            value={transmission.projectSite.changeRequest[0].dates}
          />
        </Form.Group>
        <Form.TextArea
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          rows={2}
          placeholder="Remark"
          value={transmission.remark}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/projectmanagement/transmission")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(TransmissionEditForm);
